import React from 'react';

import * as S from './legend-item.styles';

export interface LegendItemProps {
  logoUrl: string;
  ticker: string;
  resample: string;
  exchange: string;
  price: string;
  priceChange: string;
  name: string;
  isPrimary?: boolean;
  legendColor: string;
}

export const LegendItem = ({
  logoUrl,
  ticker,
  resample,
  exchange,
  price,
  priceChange,
  name,
  isPrimary = false,
  legendColor,
}: LegendItemProps) => {
  return (
    <S.LegendItemRoot data-testid="legend-item">
      {isPrimary ? (
        <S.StyledLogo name={name} logoUrl={logoUrl} />
      ) : (
        <S.ChartLineColorDot
          data-testid="chart-line-color-dot"
          $color={legendColor}
        />
      )}
      <S.Asset $isPrimary={isPrimary}>
        <S.UpperCase>{ticker}</S.UpperCase>
        <S.SeperatorDot iconName="Dot" size={6} />
        <S.UpperCase>{resample}</S.UpperCase>
        <S.SeperatorDot iconName="Dot" size={6} />
        <S.UpperCase>{exchange}</S.UpperCase>
      </S.Asset>
      <S.Price $color={legendColor} $isPrimary={isPrimary}>
        {price}
        {priceChange}
      </S.Price>
    </S.LegendItemRoot>
  );
};
